var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"title":_vm.$t('Выберите дату последнего обновления')}},[_c('TheDatePicker',{attrs:{"name":"shedule"},on:{"shedule":_vm.setSheduleDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }